import {Component, Input} from '@angular/core';
import {ReasonDescriptionInfoComponent} from '../../../shared/card-view/reason-description-info/reason-description-info.component';
import {ReasonDescriptionInfo} from '../../../shared/card-view/reason-description-info/reason-description-info';
import {timestampToFullDateTimeWithoutComma} from '../../../utility/timestamp-functions';
import {UserLinkService} from '../../../user/user-link.service';
import {Unit} from '../../../dashboard/monitoring/unit';

@Component({
  selector: 'app-unit-write-off-info',
  templateUrl: '../../../shared/card-view/reason-description-info/reason-description-info.component.html',
})
export class UnitWriteOffInfoComponent extends ReasonDescriptionInfoComponent {
  info: ReasonDescriptionInfo;

  @Input() set unit(model: Unit) {
    this.info = {
      title: 'Reason for write-off of property',
      reasonInfo: [
        model.writtenOffByUser ? {
          routerLink: {
            route: this.userLinkService.getLink(model.writtenOffByUser),
            label: model.writtenOffByUser.login,
            iconName: model.writtenOffByUser.role ? 'icon ic_' + model.writtenOffByUser.role + '_dark' : '',
          }
        } : {},
        {
          value: timestampToFullDateTimeWithoutComma(model.written_off_at_timestamp)
        }
      ],
      description: model.write_off_comment
    };
  }

  constructor(
    private userLinkService: UserLinkService
  ) {
    super();
  }
}
